/* DO NOT MODIFY. This is an autogenerated file. */
/* eslint-disable */
import * as React from "react"
import type { SVGProps } from "react"

export const SvgSecurityBadge = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width || "100%"}
    height={props.height || "100%"}
    fill="none"
    viewBox="0 0 26 31"
    data-name="SvgSecurityBadge"
    {...props}
  >
    {props.children}
    <path
      stroke="#475B8C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M24.5 15.493c0 7.286-7.947 12.585-10.839 14.272-.328.192-.493.288-.725.337-.18.04-.442.04-.622 0-.232-.05-.396-.145-.725-.337C8.697 28.078.75 22.78.75 15.493V8.394c0-1.187 0-1.78.194-2.29.172-.45.45-.853.812-1.172.41-.36.965-.569 2.076-.986l7.96-2.984c.308-.116.462-.174.62-.197q.214-.03.425 0c.16.023.313.081.622.197l7.96 2.984c1.11.417 1.666.625 2.075.986.362.32.64.721.812 1.172.194.51.194 1.103.194 2.29z"
    />
    <path
      stroke="#475B8C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M16.375 12.164v-1.5a3.75 3.75 0 1 0-7.5 0v1.5m3.75 3.375v1.5m-2.4 3.375h4.8c1.26 0 1.89 0 2.371-.245a2.25 2.25 0 0 0 .984-.983c.245-.482.245-1.112.245-2.372v-1.05c0-1.26 0-1.89-.245-2.371a2.25 2.25 0 0 0-.983-.984c-.482-.245-1.112-.245-2.372-.245h-4.8c-1.26 0-1.89 0-2.371.245a2.25 2.25 0 0 0-.984.984c-.245.48-.245 1.11-.245 2.371v1.05c0 1.26 0 1.89.245 2.372.216.423.56.767.984.983.48.245 1.11.245 2.371.245"
    />
  </svg>
)
